export enum ApplicationActionTypes {
  GET_APPLICATIONS_STARTED = "GET_APPLICATIONS_STARTED",
  GET_APPLICATIONS_SUCCESS = "GET_APPLICATIONS_SUCCESS",
  GET_APPLICATIONS_ERROR = "GET_APPLICATIONS_ERROR",
}
